module.exports = __webpack_public_path__ + "static/img/10.4f8b600.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/sp/10.png
// module id = MZ4j
// module chunks = 0